import { Link } from 'react-router-dom'

const base =
  'inline-flex min-h-11 items-center justify-center border-2 border-ink px-5 font-mono text-sm font-semibold uppercase tracking-wider no-underline disabled:cursor-not-allowed disabled:opacity-60'

const variants = {
  primary: 'bg-ink text-paper hover:bg-signal hover:border-signal',
  secondary: 'bg-paper text-ink hover:bg-ink hover:text-paper'
}

/**
 * Square ink button, 44 px tall. Pass `to` for an internal link, `href` for an
 * external one; otherwise it renders a <button>.
 */
export default function Button({ to, href, variant = 'primary', className = '', children, ...rest }) {
  const classes = `${base} ${variants[variant] ?? variants.primary} ${className}`

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    )
  }

  if (href) {
    return (
      <a href={href} className={classes} {...rest}>
        {children}
      </a>
    )
  }

  return (
    <button type="button" className={classes} {...rest}>
      {children}
    </button>
  )
}
